module.exports = __webpack_public_path__ + "img/loading_papper_9.d28772a5.png";